<!-- @veltra/icons generated sha256:d67acc8e17cfa9dd gen:8 source:src/svg/normal/house-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'HouseFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        d="M6.839 1.722c.524-.293 1.01-.467 1.553-.467.544 0 1.03.174 1.555.468.508.285 1.09.706 1.822 1.235l.946.685c.588.425 1.057.764 1.412 1.078.365.325.638.648.812 1.054.174.408.216.826.192 1.308-.022.464-.108 1.025-.216 1.724l-.198 1.288c-.152.994-.274 1.784-.452 2.4-.185.639-.446 1.144-.91 1.531-.464.386-1.015.557-1.689.64-.656.08-1.483.08-2.528.08H7.646c-1.044 0-1.872 0-2.527-.08-.674-.083-1.226-.255-1.69-.64-.464-.386-.724-.892-.91-1.53-.178-.617-.3-1.407-.451-2.401l-.199-1.288c-.107-.699-.194-1.26-.216-1.725-.023-.48.019-.899.193-1.306.173-.407.447-.73.812-1.054.354-.315.824-.654 1.412-1.079l.946-.685c.732-.529 1.315-.95 1.823-1.235m2.18 8.16a.628.628 0 1 0-1.254 0v1.883a.628.628 0 1 0 1.254 0z"
      />
    </g>
  </svg>
</template>
